// Typelizer digest 5aab305649f34067e6d4fc0b52121bdf
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/counterparties/:counterparty_id/correction */
  update: (
    params: { counterpartyId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/counterparties/:counterparty_id/correction', params, options),
    method: 'patch',
  }),
}
